import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchOffer } from "./actions";
import { IOffer } from "./types";

interface IInitialState {
  offer: IOffer | null;
  changeAmountNoticeWasShown: boolean;
}

const initialState: IInitialState = {
  offer: null,
  changeAmountNoticeWasShown: false,
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setOffer: (state, action: PayloadAction<IOffer>) => {
      state.offer = action.payload;
    },
    setNoticeShowStatus: (state, action: PayloadAction<boolean>) => {
      state.changeAmountNoticeWasShown = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchOffer.fulfilled,
      (state, action: PayloadAction<IOffer | null>) => {
        state.offer = action.payload;
      }
    );

  },
});

export const { setOffer, setNoticeShowStatus } = paymentSlice.actions;

export default paymentSlice.reducer;
